import { render, staticRenderFns } from "./EditScheduledAIP.vue?vue&type=template&id=07224d89&"
import script from "./EditScheduledAIP.vue?vue&type=script&lang=js&"
export * from "./EditScheduledAIP.vue?vue&type=script&lang=js&"
import style0 from "./EditScheduledAIP.vue?vue&type=style&index=0&id=07224d89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports